import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypesExperience = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5293 21.2741C16.4007 21.5393 16.4109 21.8513 16.5559 22.1081L18.6152 25.6368C18.7895 25.936 18.7725 26.3092 18.572 26.5919C18.3793 26.8796 18.0384 27.03 17.6961 26.9808L13.6491 26.4466C13.508 26.4268 13.3644 26.4408 13.2286 26.486L13.0205 26.5618C12.9523 26.5989 12.89 26.6476 12.8384 26.7065L10.0867 29.7282C9.94934 29.8739 9.76984 29.9733 9.57236 30.0113C9.0865 30.091 8.62539 29.7685 8.53336 29.2845L7.83986 25.258C7.7847 24.9659 7.59119 24.7189 7.32098 24.5956L3.5691 22.9189C3.25524 22.7785 3.05149 22.4701 3.04635 22.1266C3.03841 21.7851 3.22012 21.4675 3.51902 21.302L7.13309 19.3577C7.41239 19.2219 7.60293 18.9524 7.63831 18.6438L8.06324 14.5837C8.07518 14.4923 8.10088 14.4029 8.14124 14.3204L8.19075 14.2415C8.21229 14.1884 8.24171 14.1403 8.27798 14.0966L8.35048 14.0354L8.46141 13.9341L8.78464 13.8163C9.08424 13.741 9.40134 13.8211 9.62819 14.0307L12.5828 16.8416C12.7971 17.0479 13.0994 17.1352 13.3904 17.0769L17.408 16.2397C17.7473 16.1682 18.0979 16.2927 18.3166 16.5609C18.5294 16.8321 18.5658 17.2015 18.4102 17.5096L16.5293 21.2741Z",
			fill: "#F65D8B"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			filter: "url(#filter0_f_10904_4614)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12.9908 19.2322C11.2337 19.2322 9.80762 20.6586 9.80762 22.4154C9.80762 24.1728 11.2337 25.5986 12.9908 25.5986C14.7511 25.5986 16.174 24.1728 16.174 22.4154C16.174 20.6586 14.7511 19.2322 12.9908 19.2322Z",
				fill: "#FF3D22"
			})
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 5.26974,
			y: .883025,
			width: 33.2598,
			height: 33.6861,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(2.67px)",
					clipPath: "url(#bgblur_0_10904_4614_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 5.34354,
			d: "M24.1666 6.46073L24.1664 6.46167C24.5501 6.60158 24.8499 6.90136 24.9901 7.27885L25.0408 7.44566L25.0404 7.44755L26.2488 12.9892L26.2485 12.9901C26.3268 13.3588 26.5822 13.6657 26.9292 13.8117L26.9282 13.8114L32.2067 15.9826C32.6311 16.1561 32.9396 16.5242 33.0409 16.9625L33.0712 17.1544L33.0717 17.1565C33.108 17.6779 32.8391 18.1729 32.3819 18.4271L32.3812 18.4259L27.2788 21.2923C26.9567 21.4787 26.7465 21.8125 26.7154 22.1839L26.332 27.8531L26.333 27.8534C26.2972 28.3764 25.9582 28.8284 25.4675 29.0134L25.4682 29.0146C24.9823 29.2115 24.4275 29.1104 24.0403 28.7585L19.7986 24.986L19.7977 24.9858C19.6972 24.8949 19.5815 24.8222 19.4559 24.771L19.3269 24.7275L19.0399 24.6554C18.9473 24.6471 18.8532 24.6533 18.7637 24.6766L18.7625 24.6773L13.2361 26.0094L13.234 26.0099L13.2342 26.0089C12.9398 26.0745 12.6321 26.047 12.3535 25.9276L12.3497 25.9266C11.6735 25.6137 11.3698 24.8178 11.6654 24.1335L11.6669 24.1319L14.0099 18.955C14.159 18.6095 14.1318 18.2136 13.9365 17.8924L10.9254 13.0335C10.6512 12.5903 10.6579 12.0298 10.9437 11.5942C11.2235 11.1606 11.7205 10.9176 12.2348 10.9641L12.2357 10.9643L17.9136 11.5462L17.9185 11.5465L18.0647 11.558C18.4036 11.5633 18.7311 11.4183 18.9557 11.1576L22.6136 6.81461L22.6153 6.81201C22.7076 6.70804 22.8165 6.61779 22.9384 6.54783L22.9491 6.54145L23.0678 6.48972C23.1393 6.44421 23.2151 6.40991 23.2951 6.38673L23.3143 6.38249L23.4458 6.3682L23.4455 6.36915L23.6483 6.33955L23.6912 6.34126L24.1666 6.46073Z",
			fill: "url(#paint0_linear_10904_4614)",
			stroke: "url(#paint1_linear_10904_4614)",
			strokeWidth: .222647,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_10904_4614",
				x: 5.35467,
				y: 14.7792,
				width: 15.2721,
				height: 15.2724,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.22647,
						result: "effect1_foregroundBlur_10904_4614"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_10904_4614_clip_path",
				transform: "translate(-5.26974 -0.883025)",
				children: /* @__PURE__ */ _jsx("path", { d: "M24.1666 6.46073L24.1664 6.46167C24.5501 6.60158 24.8499 6.90136 24.9901 7.27885L25.0408 7.44566L25.0404 7.44755L26.2488 12.9892L26.2485 12.9901C26.3268 13.3588 26.5822 13.6657 26.9292 13.8117L26.9282 13.8114L32.2067 15.9826C32.6311 16.1561 32.9396 16.5242 33.0409 16.9625L33.0712 17.1544L33.0717 17.1565C33.108 17.6779 32.8391 18.1729 32.3819 18.4271L32.3812 18.4259L27.2788 21.2923C26.9567 21.4787 26.7465 21.8125 26.7154 22.1839L26.332 27.8531L26.333 27.8534C26.2972 28.3764 25.9582 28.8284 25.4675 29.0134L25.4682 29.0146C24.9823 29.2115 24.4275 29.1104 24.0403 28.7585L19.7986 24.986L19.7977 24.9858C19.6972 24.8949 19.5815 24.8222 19.4559 24.771L19.3269 24.7275L19.0399 24.6554C18.9473 24.6471 18.8532 24.6533 18.7637 24.6766L18.7625 24.6773L13.2361 26.0094L13.234 26.0099L13.2342 26.0089C12.9398 26.0745 12.6321 26.047 12.3535 25.9276L12.3497 25.9266C11.6735 25.6137 11.3698 24.8178 11.6654 24.1335L11.6669 24.1319L14.0099 18.955C14.159 18.6095 14.1318 18.2136 13.9365 17.8924L10.9254 13.0335C10.6512 12.5903 10.6579 12.0298 10.9437 11.5942C11.2235 11.1606 11.7205 10.9176 12.2348 10.9641L12.2357 10.9643L17.9136 11.5462L17.9185 11.5465L18.0647 11.558C18.4036 11.5633 18.7311 11.4183 18.9557 11.1576L22.6136 6.81461L22.6153 6.81201C22.7076 6.70804 22.8165 6.61779 22.9384 6.54783L22.9491 6.54145L23.0678 6.48972C23.1393 6.44421 23.2151 6.40991 23.2951 6.38673L23.3143 6.38249L23.4458 6.3682L23.4455 6.36915L23.6483 6.33955L23.6912 6.34126L24.1666 6.46073Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_10904_4614",
				x1: 23.9755,
				y1: 6.52749,
				x2: 18.7125,
				y2: 27.4724,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFC2D3" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF9CB6"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_10904_4614",
				x1: 15.8478,
				y1: 7.07936,
				x2: 24.7235,
				y2: 27.6067,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .25
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgTypesExperience;
